import { AutodeskLayerApiModel } from '../../../types/models/autodesk-layer.model';
import { CreateAutodeskLayerApiRequest } from '../../../types/requests/autodesk-layers/create-autodesk-layer.request';
import { DeleteAutodeskLayerApiRequest } from '../../../types/requests/autodesk-layers/delete-autodesk-layer.request';
import { GetAutodeskLayerApiRequest } from '../../../types/requests/autodesk-layers/get-autodesk-layer.request';
import { SearchAutodeskLayersApiRequest } from '../../../types/requests/autodesk-layers/search-autodesk-layers.request';
import { UpdateAutodeskLayerApiRequest } from '../../../types/requests/autodesk-layers/update-autodesk-layer.request';
import { CursorPaginatedApiResponse } from '../../../types/responses/cursor-paginated.response';
import { client } from './client';

export const createAutodeskLayer = (params: CreateAutodeskLayerApiRequest) =>
  client.post<AutodeskLayerApiModel>('/autodesk-layers', params);

export const updateAutodeskLayer = ({ autodeskLayerId, ...params }: UpdateAutodeskLayerApiRequest) =>
  client.patch<AutodeskLayerApiModel>(`/autodesk-layers/${autodeskLayerId}`, params);

export const getAutodeskLayer = <T extends AutodeskLayerApiModel>({
  autodeskLayerId,
  ...params
}: GetAutodeskLayerApiRequest) => client.get<T>(`/autodesk-layers/${autodeskLayerId}`, { params });

export const searchAutodeskLayers = <T extends AutodeskLayerApiModel>(params: SearchAutodeskLayersApiRequest) =>
  client.get<CursorPaginatedApiResponse<T>>(`/autodesk-layers`, { params });

export const deleteAutodeskLayer = ({ autodeskLayerId }: DeleteAutodeskLayerApiRequest) =>
  client.delete<void>(`/autodesk-layers/${autodeskLayerId}`);
